import React from 'react';
import MobilebillingappHeader from '../MobilebillingappHeader';
import MobilebillingappContent from '../MobilebillingappContent';
import '../Mobilebillingapp.css';

const MobilebillingappServer = () => {
    return (
        <div className="mobilebillingapp-page">
            <MobilebillingappHeader />
            <MobilebillingappContent />
        </div>
    );
};

export default MobilebillingappServer;
